import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import OrganizationService from "../../services/OrderingServices/OrganizationService";

const DetailOrgDbModal = ({ isOpen, toggleModal,detailData,isEdit,setIsEdit }) => {

 console.log(detailData)
 const initialValues = {
 
    hostName: detailData?.hostName || "",
    server: detailData?.server || "",
    dbName: detailData?.dbName || "",
    dbUser: detailData?.dbUser || "",
    dbPassword:  null,
    adminEmail: detailData?.adminEmail || "",
  };



const validationSchema = Yup.object({


  hostName: Yup.string()
    .required("Host Name is required"),

  server: Yup.string()
    .required("Server is required"),

  dbName: Yup.string()
    .required("Database Name is required"),

  dbUser: Yup.string()
    .required("Database User is required"),

//   dbPassword: Yup.string()
//     .required("Password is required")
//     .min(8, "Password must be at least 8 characters long")
//     .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
//     .matches(/[a-z]/, "Password must contain at least one lowercase letter")
//     .matches(/[0-9]/, "Password must contain at least one number")
//     .matches(/[@$!%*?&#]/, "Password must contain at least one special character"),
    dbPassword: Yup.string()
    .nullable()
    .test(
    "strong-password",
    "Password must be at least 8 characters long, contain uppercase, lowercase, number, and special character",
    function (value) {
    if (!value) return true; // Accept null or empty string
    const hasMinLength = value.length >= 8;
    const hasUpper = /[A-Z]/.test(value);
    const hasLower = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecial = /[@$!%*?&#]/.test(value);
    return hasMinLength && hasUpper && hasLower && hasNumber && hasSpecial;
    }),

  adminEmail: Yup.string()
    .email("Invalid email format")
    .required("Admin Email is required"),
});

  const handleSubmit = async (values) => {
    try {
        

    //     console.log(values)
    //      const res = await OrganizationService.updateOrgDatabase({
    //     data: values,
    //     id: detailData.id
    //   });
   

     console.log(values);

  const formData = new FormData();

  // Append each key-value pair from values to FormData
  Object.entries(values).forEach(([key, value]) => {
    formData.append(key, value);
  });

  // Now call your service method with formData
  const res = await OrganizationService.updateOrgDatabase({
    data: formData,
    id: detailData.id
  });
     console.log(res);
      toggleModal()
      setIsEdit(false)
      toast.success(" Organization Database Updated! ");

    
    } catch (err) {
      toast.error("Error In Updating New Database! ");
      console.log(err);
    }
  };

  return (<>

    {
        !isEdit ?
    //show details
   <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader  toggle={toggleModal}>
     
        <div className="fw-bold fs-4">{detailData.orgNanme}</div>
        <div className="fs-12 text-muted">{detailData?.createdDate?.split('T')[0]}</div>
    
      </ModalHeader>
      <ModalBody>
       
        <Row>
            <Col sm={6}>
                <Label>Database: </Label> {" "}
                <span>{ detailData?.dbName}</span>
            </Col>

            <Col sm={6}>
                <Label>Server: </Label>{" "}
                <span>{detailData?.server}</span>
            </Col>
            <Col sm={6}>
                <Label>HostName: </Label>{" "}
                <span>{detailData?.hostName}</span>
            </Col>
            <Col sm={6}>
                <Label>Database User: </Label>{" "}
                <span>{detailData?.dbUser}</span>
            </Col>
             <Col sm={6}>
                <Label>Admin's Email: </Label>{" "}
                <span>{detailData?.adminEmail}</span>
            </Col>
        </Row>

      </ModalBody>
      <ModalFooter>
        Created By: {detailData?.createdBy}
      </ModalFooter>
    </Modal>

    :

    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader  toggle={toggleModal}>
     
       Update Organization Database
    
      </ModalHeader>
      <ModalBody>
       
           <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue, values }) => (
                    <Form>
                      <Row>
                        
                        <Col md={6} className="mb-2">
                          <Label for="adminEmail">Email: </Label>
                          <Input
                            name="adminEmail"
                            value={values.adminEmail}
                            onChange={(e) =>
                              setFieldValue("adminEmail", e.target.value)
                            }
                            placeholder="Enter adminEmail"
                            className="form-control"
                            id="adminEmail"
                          />
                          <ErrorMessage
                            name="adminEmail"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                        <Col md={6} className="mb-2">
                          <Label for="dbPassword">Password: </Label>
                          <Input
                            name="dbPassword"
                            type="password"
                            value={values.dbPassword}
                            onChange={(e) =>
                              setFieldValue("dbPassword", e.target.value)
                            }
                            placeholder="Enter dbPassword"
                            className="form-control"
                            id="dbPassword"
                          />
                          <ErrorMessage
                            name="dbPassword"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
        
                        <Col md={6} className="mb-2">
                          <Label for="hostName">Hostname: </Label>
                          <Input
                            name="hostName"
                            type="text"
                            value={values.hostName}
                            onChange={(e) => setFieldValue("hostName", e.target.value)}
                            placeholder="Enter hostName"
                            className="form-control"
                            id="hostName"
                          />
                          <ErrorMessage
                            name="hostName"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                        <Col md={6} className="mb-2">
                          <Label for="server">Server: </Label>
                          <Input
                            name="server"
                            type="text"
                            value={values.server}
                            onChange={(e) => setFieldValue("server", e.target.value)}
                            placeholder="Enter server"
                            className="form-control"
                            id="server"
                          />
                          <ErrorMessage
                            name="server"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                        <Col md={6} className="mb-2">
                          <Label for="dbName">Database Name: </Label>
                          <Input
                            name="dbName"
                            type="text"
                            value={values.dbName}
                            onChange={(e) => setFieldValue("dbName", e.target.value)}
                            placeholder="Enter dbName"
                            className="form-control"
                            id="dbName"
                          />
                          <ErrorMessage
                            name="dbName"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                        <Col md={6} className="mb-2">
                          <Label for="dbUser">Database User: </Label>
                          <Input
                            name="dbUser"
                            as="textarea"
                            value={values.dbUser}
                            onChange={(e) => setFieldValue("dbUser", e.target.value)}
                            placeholder="Enter dbUser"
                            className="form-control"
                            id="hostName"
                          />
                          <ErrorMessage
                            name="dbUser"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                      </Row>
        
                      <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>
                          Cancel
                        </Button>
                        <Button color="primary" type="submit" >
                          Update
                        </Button>
                      </ModalFooter>
                    </Form>
                  )}
                </Formik>

      </ModalBody>
    
    </Modal>



    }
  </>);
};

export default DetailOrgDbModal;
